<template>
  <div id="userlayout" class="userlayout space_between full_layout" v-loading.fullscreen="loading">
    <div class="userLeft">
      <div class="userhead">
        <span :class="reversedLevel">
          <img src="../../../static/images/userHeadPortrait.svg">
        </span>
        <div>{{userInfo.NickName}}</div>
      </div>
      <ul class="userMenu">
        <li :class="{'on':(isWhat[0]=='user'&&isWhat[1]=='info')}">
          <router-link :to="{path:'/user/info'}">{{$t('AccountInfo')}}</router-link>
        </li>
        <li :class="{'on':(isWhat[0]=='user'&&isWhat[1]=='order')}">
          <router-link :to="{path:'/user/order'}">{{$t('OrderHistory')}}</router-link>
        </li>
        <!-- <li>
          <router-link :to="{path:'/message'}">{{$t('Notifications')}}</router-link>
        </li> -->
        <li :class="{'on':(isWhat[0]=='user'&&isWhat[1]=='address')}">
          <router-link :to="{path:'/user/address'}">{{$t('ShippingAddresses')}}</router-link>
        </li>
        <li>
          <router-link :to="{path:'/cart'}">{{$t('ShoppingCart')}}</router-link>
        </li>
        <li :class="{'on':(isWhat[0]=='user'&&isWhat[1]=='point')}">
          <router-link :to="{path:'/user/point'}">{{$t('Points')}}</router-link>
        </li>
        <li :class="{'on':(isWhat[0]=='user'&&isWhat[1]=='exchangeInfo')}">
          <router-link :to="{path:'/user/exchangeInfo'}">{{$t('TradeCards')}}</router-link>
        </li>
        <li @click="logout">
          <span>{{$t('SignOut')}}</span>
        </li>
      </ul>
    </div>
    <router-view @updata="updata"></router-view>
  </div>
</template>
<script>
import { getInfo,toLogout} from "@/api/public";
export default {
  name: 'userlayout',
  components: { },
  data() {
    return {
      userInfo:getInfo(),
      loading:false,
      isWhat:this.$route.path.slice(1).split("/"),
    }
  },
  watch:{
    '$route':'getPath'
  },
  mounted() {
    this.$root.$on("newName",val => {
      this.userInfo=getInfo()
    })
  },
  created() {
    if(this.userInfo!=null){}
    
    //this.userInfo=getInfo()
  },
  computed:{
    reversedLevel(){
      let lv=''
      let that=this
      if(that.userInfo&&that.userInfo.Level>1){
        lv='lv lv'+that.userInfo.Level
      }
      return lv
    }
  },
  methods: {
    updata(val){
      if(val=='info'){
        this.userInfo=getInfo()
      }
    },
    logout(){
      this.loading=true;
      toLogout()
    },
    getPath(){
      this.isWhat=this.$route.path.slice(1).split("/")
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/user.css";

</style>



// WEBPACK FOOTER //
// src/pages/user/userlayout.vue